/* eslint-disable no-underscore-dangle */

import { NAV_DATA_KEY } from '../../../app/constants/app';

// eslint-disable-next-line no-var
var HerokuBoomerangService = class HerokuBoomerangService {
  // eslint-disable-next-line class-methods-use-this
  init() {
    if (Boomerang) {
      try {
        if (window.localStorage.getItem(NAV_DATA_KEY)) {
          const navData = JSON.parse(atob(window.localStorage.getItem(NAV_DATA_KEY)));
          Boomerang.init({ app: navData.appname, addon: 'xplenty' });
        } else {
          Boomerang.reset();
        }
      } catch (e) {
        console.log('An error occured loading Boomerang: ', e);
      }
    }
  }
};

xplenty.service('herokuBoomerangService', [HerokuBoomerangService]);
